<template>
  <div class="col-lg-12 w-100">
    <div class="card flex-fill mb-3">
      <div class="pro-head">
        <h4 class="pro-titles without-border mb-0">Education</h4>
      </div>
      <div class="pro-body">
        <div class="form-row align-items-center skill-cont">
          <div class="input-block col-lg-3">
            <label class="form-label">Degree Name</label>
            <input type="text" class="form-control" value="BE CSE" />
          </div>
          <div class="input-block col-lg-3">
            <label class="form-label">University Name</label>
            <input type="text" class="form-control" value="Brington" />
          </div>
          <div class="col-md-3 input-block floating-icon">
            <label class="form-label">Start Date</label>
            <datepicker
              v-model="startdate"
              placeholder="Choose"
              class="form-control datetimepicker"
              :editable="true"
              :clearable="false"
            />
          </div>
          <div class="col-md-2 input-block floating-icon">
            <label class="form-label">End Date</label>
            <datepicker
              v-model="startdateOne"
              placeholder="Choose"
              class="form-control datetimepicker"
              :editable="true"
              :clearable="false"
            />
          </div>
          <div class="input-block col-lg-1 mb-0">
            <a
              href="javascript:void(0);"
              class="btn trash-icon"
              @click="deleteeducation(index)"
              ><i class="far fa-trash-alt"></i
            ></a>
          </div>
          <div id="education_add_row" class="w-100">
            <div
              class="col-lg-12 w-100"
              v-for="(educations, index) in educations"
              :key="index"
            >
              <div class="card flex-fill mb-3">
                <div class="pro-head">
                  <h4 class="pro-titles without-border mb-0">Education</h4>
                </div>
                <div class="pro-body">
                  <div class="form-row align-items-center skill-cont">
                    <div class="input-block col-lg-3">
                      <label class="form-label">Degree Name</label>
                      <input type="text" class="form-control" value="BE CSE" />
                    </div>
                    <div class="input-block col-lg-3">
                      <label class="form-label">University Name</label>
                      <input type="text" class="form-control" value="Brington" />
                    </div>
                    <div class="col-md-3 input-block floating-icon">
                      <label class="form-label">Start Date</label>
                      <datepicker
                        v-model="startdateTwo"
                        placeholder="Choose"
                        class="form-control datetimepicker"
                        :editable="true"
                        :clearable="false"
                      />
                    </div>
                    <div class="col-md-2 input-block floating-icon">
                      <label class="form-label">End Date</label>
                      <datepicker
                        v-model="startdateThree"
                        placeholder="Choose"
                        class="form-control datetimepicker"
                        :editable="true"
                        :clearable="false"
                      />
                    </div>
                    <div class="input-block col-lg-1 mb-0">
                      <a
                        href="javascript:void(0);"
                        class="btn trash-icon"
                        @click="deleteeducation(index)"
                        ><i class="far fa-trash-alt"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <a
            href="javascript:void(0)"
            class="add-btn-form add-edu w-100 d-block text-end"
            @click="addeducation"
            ><i class="feather-plus-circle me-2"></i>Add New</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
const currentDateTwo = ref(new Date());
const currentDateThree = ref(new Date());
export default {
  data() {
    return {
      educations: [],
      startdate: currentDate,
      startdateOne: currentDateOne,
      startdateTwo: currentDateTwo,
      startdateThree: currentDateThree,
    };
  },
  methods: {
    addeducation() {
      this.educations.push({});
    },
    deleteeducation(index) {
      this.educations.splice(index, 1);
    },
  },
};
</script>
